import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const SignatureQualifiedIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        stroke={iconColor}
        strokeWidth={1.5}
        d="M4 19.467h16m-9.067-8.534v3.2m2.134-3.2v3.2M12 10.933a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4Zm-7.467 6.4v-1.066c0-1.178.955-2.134 2.134-2.134h10.666c1.179 0 2.134.956 2.134 2.134v1.066H4.533Z"
      />
    </Box>
  );
};
